import { render, staticRenderFns } from "./zhipaiCYS.vue?vue&type=template&id=48d6dfca&scoped=true&"
import script from "./zhipaiCYS.vue?vue&type=script&lang=js&"
export * from "./zhipaiCYS.vue?vue&type=script&lang=js&"
import style0 from "./zhipaiCYS.vue?vue&type=style&index=0&id=48d6dfca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d6dfca",
  null
  
)

export default component.exports